import * as React from "react";
import { Progress } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function ProgressDemo() {
  const [value, setValue] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setValue((v) => (v >= 100 ? 0 : v + 7));
    }, 700);
    return () => clearInterval(timer);
  }, []);

  return (
    <Section
      id="progress"
      title="Progress"
      description="Determinate progress bar. For indeterminate loaders, use AikoLoader from @aisquare/pretty."
    >
      <VariantBlock label="Static values">
        <div className="w-80 space-y-3">
          <Progress value={0} />
          <Progress value={33} />
          <Progress value={66} />
          <Progress value={100} />
        </div>
      </VariantBlock>

      <VariantBlock label="Animated (auto-incrementing)">
        <div className="w-80">
          <Progress value={value} />
          <p className="mt-1 text-xs text-muted-foreground">{value}%</p>
        </div>
      </VariantBlock>
    </Section>
  );
}
